import Vue from 'vue';
import router from './router';
import store from './store';
import App from './App';

import './validation';

import VuePhotoSwipe from './plugins/PhotoSwipe';
Vue.use(VuePhotoSwipe);

import VueAwesomeSwiper from 'vue-awesome-swiper';
Vue.use(VueAwesomeSwiper);

import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload);

import lineClamp from 'vue-line-clamp';
Vue.use(lineClamp);

import PortalVue from 'portal-vue';
Vue.use(PortalVue);

import Calendar from 'v-calendar/lib/components/calendar.umd';
Vue.component('calendar', Calendar);

import VTooltip from 'v-tooltip';
Vue.use(VTooltip)

import VueTouchEvents from 'vue2-touch-events';
Vue.use(VueTouchEvents);

import VueProgressBar from 'vue-progressbar';
Vue.use(VueProgressBar, {
    color: '#e30018',
    failedColor: '#fac428',
    // thickness: '5px',
    transition: {
        speed: '0.2s',
        opacity: '0.6s',
        termination: 100,
    },
    position: 'absolute',
});

Vue.component('modal', {
    template: `
        <transition name="modal" mode="out-in">
            <slot></slot>
        </transition>
    `,
});

// import Sticky from 'vue-sticky-directive'
// Vue.use(Sticky)

import TreeMenu from '@/components/TreeMenu';
Vue.component('tree-menu', TreeMenu);

import { apolloProvider } from './store/apollo';

import '@/init';
import '@/router/middleware';

import '@/fontawesome';
import '@/filters';

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    apolloProvider,
    render: (h) => h(App),
}).$mount('#app');
